import Immutable from 'immutable';
import moment from 'moment';

import MomentSupport from 'sharedreact/utils/MomentSupport';

const Content: {
  id: string,
  name: string,
  url: string,
  modificationDate: moment.Moment | null;
  kind: string,
  fileType: string,
  fileSize: number,
  jobId: string | null,
  location: string,
  locked: boolean // if true, entry can't be renamed, deleted...
} = {
  id: '',
  name: '',
  url: '',
  modificationDate: null,
  kind: '',
  fileType: '',
  fileSize: 0,
  jobId: null,
  location: '',
  locked: false
};

class FolderEntry extends Immutable.Record(Content) {
  static fromJS (json: object): FolderEntry {
    return new FolderEntry(Immutable.Map<string, unknown>(json).map(MomentSupport.itemToMoment));
  }

  get filename (): string {
    return this.name;
  }

  get folder (): string {
    const urlWithoutTrailingSlash = this.url.replace(/\/$/, '');
    return urlWithoutTrailingSlash.substring(0, urlWithoutTrailingSlash.lastIndexOf('/'));
  }

  get fileUrl (): string {
    return this.url;
  }

  get extension (): string {
    const extensionSepPos: number = this.name.lastIndexOf('.');
    return extensionSepPos !== -1 ? this.name.substr(extensionSepPos + 1) : '';
  }

  get displayFileType (): string {
    return this.fileType || this.extension.toUpperCase();
  }
}

export default FolderEntry;
